/* eslint-disable no-extend-native */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
/* eslint-disable default-case */
import React, { useEffect, useState } from 'react'
import { Container } from 'react-bootstrap';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import 'react-select-search/style.css'
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import { FormControl, FormControlLabel, FormLabel, Input, InputLabel, Radio, RadioGroup } from '@mui/material';
import { DatePicker, DateTimePicker } from '@mui/x-date-pickers';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { renderDigitalClockTimeView } from '@mui/x-date-pickers/timeViewRenderers';
import dayjs from 'dayjs';
import { getDownloadURL, getStorage, ref, uploadBytesResumable } from "firebase/storage";
import Button from '@mui/material/Button';
import { CloudUpload } from '@mui/icons-material';
import Cropper from 'react-easy-crop';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Slider from '@mui/material/Slider';
import { addEvent, updateEvent } from '../services/event-services'
import Snackbar from '@mui/material/Snackbar';
import { useCookies } from "react-cookie";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate } from 'react-router-dom';
import { refreshAuthToken } from '../services/auth-services';

export default function CreateEventForm(props) {
  const userState = { props }
  const [venues, setVenues] = useState()
  const [loading, setLoading] = useState(true)
  const [startDate, setStartDate] = useState(dayjs(new Date()).toString())
  const [venueId, setVenueId] = useState();
  const [eventType, setEventType] = useState();
  const [eventName, setEventName] = useState()
  const [eventDescription, setEventDescription] = useState()
  const [daily, setDaily] = useState(false);
  const [weekly, setWeekly] = useState(false)
  const [endDate, setEndDate] = useState(dayjs(new Date()).toString())
  const [startTime, setStartTime] = useState()
  const [endTime, setEndTime] = useState()
  const [file, setFile] = useState("");
  const storage = getStorage();
  const { v4: uuidv4 } = require('uuid');
  const [imageFile, setImageFile] = useState()
  const [occurrence, setOccurrence] = useState("oneOff")
  const [dayOfTheWeek, setDayOfTheWeek] = useState()
  const [success, setSuccess] = useState(false)
  const [successMessage, setSuccessMessage] = useState("")
  const [cookie, setCookie, removeCookie] = useCookies(['whatson'], "/");
  const [editMode, setEditMode] = useState(false)
  const [eventId, setEventId] = useState()
  const [imageFileValidationError, setImageFileValidationError] = useState(false)
  const [cropModalOpen, setCropModalOpen] = useState(false)
  const [cropSrc, setCropSrc] = useState(null)
  const [crop, setCrop] = useState({ x: 0, y: 0 })
  const [zoom, setZoom] = useState(1)
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null)
  const [pendingFile, setPendingFile] = useState(null)
  const navigate = useNavigate()


  useEffect(() => {
    const loadVenues = async () => {
      console.log(props)
      if (props.eventData instanceof Array) {
        var eventData = props.eventData[0]
        console.log(eventData)
        setEventId(eventData.eventId)
        setEventName(eventData.eventTitle)
        setEventDescription(eventData.eventDescription)
        setEventType(getEventOption(parseInt(eventData.eventType)))
        setFile(eventData.eventImage)
        if (!eventData.isWeeklyEvent && !eventData.isDailyEvent) {
          setOccurrence("oneOff")
        } else {
          setWeekly(true)
          setOccurrence("weekly")
        }
        setDayOfTheWeek(calculateDayOfTheWeek(eventData))
        setVenueId(eventData.venueId)
        setStartDate(dayjs(getNearestHour(new Date(eventData.eventStartDate).setHours(eventData.eventStartTime.split(":")[0], eventData.eventStartTime.split(":")[1]))).toString())
        

          console.log("is edit mode")
          var eventStartTimeHours = eventData.eventStartTime.split(":")[0];
          var eventStartTimeMinutes = eventData.eventStartTime.split(":")[1];
          var eventStartDate = eventData.eventStartDate.split("T")[0];
          var eventEndTimeHours = eventData.eventEndTime.split(":")[0];
          var eventEndTimeMinutes = eventData.eventEndTime.split(":")[1];
          var eventEndDate = eventData.eventEndDate.split("T")[0];
          setStartTime(dayjs((new Date(`${eventStartDate}T${eventStartTimeHours}:${eventStartTimeMinutes}:00`))).toString())
          setEndTime(dayjs((new Date(`${eventEndDate}T${eventEndTimeHours}:${eventEndTimeMinutes}:00`))).toString())
        setEndDate(dayjs(getNearestHour(new Date(eventData.eventEndDate).setHours(eventData.eventEndTime.split(":")[0], eventData.eventEndTime.split(":")[1]))).toString())
        setEditMode(true)
        setLoading(false)
      }
      else {
        setVenues(props.allVenues)
        setStartDate(dayjs(getNearestHour(new Date().toString())))
        setStartTime(dayjs(getNearestHour(new Date().toString())))
        setEndDate(dayjs(getNearestHour(new Date().toString())))
        setEndTime(dayjs(getNearestHour(new Date().addHours(1).toString())))
        var dayOfWeek = dayjs(dayjs(getNearestHour(new Date().toString()))).day()
        let day = daysOfTheWeek.find(x => x.value === dayOfWeek)
        console.log(day)
        setDayOfTheWeek(day)
        setLoading(false)
      }
    }
    loadVenues();
  }, [])

  const options = [
    { label: 'Music', value: 1 },
    { label: 'Food', value: 2 },
    { label: 'Sport', value: 3 },
    { label: 'Other', value: 4 },
  ];

  const getEventOption = (value) => {
    let obj = options.find(o => o.value === value);
    return obj
  }

  const getNearestHour = (eventData) => {
    let now = new Date(eventData);

    // Get the current hour and minute
    let hour = now.getHours();
    let minute = now.getMinutes();

    // Round the minute to the nearest 30-minute interval
    if (minute <= 30) {
      now.setMinutes(30);
    } else {
      now.setHours(hour + 1, 0);
    }
    return dayjs(now)
  }

  const calculateDayOfTheWeek = (row) => {
    const eventDay = row?.eventDayOfWeek;

    if (typeof eventDay !== "string" || eventDay.trim().length <= 1) {
      const dayOfWeek = dayjs(row?.eventStartDate).day();
      return daysOfTheWeek.find(x => x.value === dayOfWeek);
    }

    return daysOfTheWeek.find(x => x.label === eventDay);
  }

  const daysOfTheWeek = [
    { label: 'Monday', value: 1 },
    { label: 'Tuesday', value: 2 },
    { label: 'Wednesday', value: 3 },
    { label: 'Thursday', value: 4 },
    { label: 'Friday', value: 5 },
    { label: 'Saturday', value: 6 },
    { label: 'Sunday', value: 0 }
  ]

  // Create the file metadata
  /** @type {any} */
  const metadata = {
    contentType: 'image/jpeg'
  };

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setSuccess(false);
  };

  const validateForm = () => {
    if (eventName === undefined || eventName.length === 0) {
      window.alert("Event name is empty")
      return true;
    }

    if (eventType === undefined || eventType === null || eventType.length === 0) {
      window.alert("Event type has not been set")
      return true;
    }

    if (eventDescription === undefined || eventDescription.length === 0) {
      window.alert("Event description is empty")
      return true;
    }

    if (dayOfTheWeek === undefined || dayOfTheWeek === null) {
      window.alert("Please select day of the week")
      return true;
    }
    if (editMode === false) {
      if (imageFile === undefined || imageFile.length === 0) {
        window.alert("Event Image is required");
        return true;
      }
    }


    var endTimeAsDate = new Date(endTime);
    const endtimestamp = endTimeAsDate.getTime();
    var startTimeAsDate = new Date(startTime);
    const starttimestamp = startTimeAsDate.getTime();

    if (endtimestamp < starttimestamp) {
      window.alert("End time must be after start time")
      return true;
    }

    if (weekly) {
      if (typeof dayOfTheWeek !== "object") {
        window.alert("If the event is a weekly event, please select the day of the week the event occurs")
        return true;
      }
    }
    return false;
  }

  const handleFormSubmit = () => {
    var validation = validateForm()
    if (validation) {
      return;
    }

    var data = {
      EventTitle: eventName,
      EventType: eventType.value,
      EventDescription: eventDescription,
      EventStartDate: dayjs(startDate).format("YYYY-MM-DD"),
      EventEndDate: dayjs(endDate).format("YYYY-MM-DD"),
      EventStartTime: dayjs(startTime).format("HH:mm:ss"),
      EventEndTime: dayjs(endTime).format("HH:mm:ss"),
      IsDailyEvent: (daily),
      IsWeeklyEvent: (weekly),
      EventDayOfWeek: weekly && dayOfTheWeek ? dayOfTheWeek.label : null,
      Venue: {}
    };

    if (!editMode) {
      var computedVenueId = userState.props.userRole === 1 ? venueId : cookie.whatson.venueId
      data.Venue.VenueId = computedVenueId
    }
    else {
      data.EventId = eventId
    }

    if (imageFile !== undefined) {
      handleCloudUpload().then(downloadUrl => {
        console.log(downloadUrl)
        data.EventImage = downloadUrl
        handleCreateUpdateEvent(data)
      })
    } else {
      data.EventImage = file
      handleCreateUpdateEvent(data)
    }
  }

  const handleCreateUpdateEvent = (data) => {

    if (!editMode) {
      console.log(data)
      addEvent(data, props.refreshToken).then(() => {
        props.refreshForm()
      }).catch(error => {
        console.log(error)
        setSuccessMessage("There was an issue adding your event")
        setSuccess(true)
      })
    }
    else {
      console.log(data)
      updateEvent(data, props.refreshToken).then(response => {
        setSuccessMessage("Updated event successfully")
        setSuccess(true)
      }).catch(error => {
        console.log(error)
        setSuccessMessage("There was an error updating your event")
        setSuccess(true)
      })
    }
  }

  const displayVenueSearch = () => {
    if (!loading && !(props.eventData instanceof Array) && userState.props.userRole === 1) {
      return (
        <Col md={6} className='mb-3'>
          <Autocomplete
            value={venueId}
            onChange={(event, newValue) => {
              newValue == null ? setVenueId(null) : setVenueId(newValue.value);
            }}
            disablePortal
            data-testid="combo-box-create-event-venue-search"
            options={venues}
            isOptionEqualToValue={(option, value) => option.id === value.id}
            renderInput={(params) => <TextField {...params} label="Venue" />}
          />

        </Col>

      )
    }
  }

  const displayCaputredImage = () => {
    if (file) {
      return (
        <Row>
          <Col>
            <img src={file} alt="venue" style={{ maxHeight: 200 }} />
          </Col>
        </Row>

      )
    }
  }

  const handleCloudUpload = () => {
    return new Promise((resolve) => {
      const stableFile = new File([imageFile], imageFile.name, { type: imageFile.type });
      var fileName = uuidv4()
      const storageRef = ref(storage, `/images/${fileName}`);
      const uploadTask = uploadBytesResumable(storageRef, stableFile, metadata);

      uploadTask.on('state_changed',
        (snapshot) => {
          // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
          const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          switch (snapshot.state) {
            case 'paused':
              break;
            case 'running':
              break;
          }
        },
        (error) => {
          // A full list of error codes is available at
          // https://firebase.google.com/docs/storage/web/handle-errors
          switch (error.code) {
            case 'storage/unauthorized':
              // User doesn't have permission to access the object
              break;
            case 'storage/canceled':
              // User canceled the upload
              break;

            // ...

            case 'storage/unknown':
              // Unknown error occurred, inspect error.serverResponse
              break;
          }
          console.log(error)
        },
        () => {
          // Upload completed successfully, now we can get the download URL
          getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
            resolve(downloadURL);
          });
        }
      )
    })
  };

  const cropAndCompressToFile = (imageSrc, pixelCrop, originalName) => {
    return new Promise((resolve) => {
      const MAX_SIZE = 1200;
      const QUALITY = 0.85;
      const img = new Image();
      img.onload = () => {
        const cropWidth = Math.max(1, Math.round(pixelCrop?.width || img.width));
        const cropHeight = Math.max(1, Math.round(pixelCrop?.height || img.height));
        const sourceX = Math.max(0, Math.round(pixelCrop?.x || 0));
        const sourceY = Math.max(0, Math.round(pixelCrop?.y || 0));
        const scale = Math.min(1, MAX_SIZE / Math.max(cropWidth, cropHeight));
        const outputWidth = Math.max(1, Math.round(cropWidth * scale));
        const outputHeight = Math.max(1, Math.round(cropHeight * scale));

        const canvas = document.createElement('canvas');
        canvas.width = outputWidth;
        canvas.height = outputHeight;
        const ctx = canvas.getContext('2d');
        ctx.drawImage(
          img,
          sourceX, sourceY,
          cropWidth, cropHeight,
          0, 0, outputWidth, outputHeight
        );
        canvas.toBlob(
          (blob) => {
            const outName = originalName.replace(/\.[^.]+$/, '.jpg');
            resolve(new File([blob], outName, { type: 'image/jpeg' }));
          },
          'image/jpeg',
          QUALITY
        );
      };
      img.src = imageSrc;
    });
  };

  const handlePreviewAndImageFile = (file) => {
    setImageFileValidationError(false)
    if (file && file.type.startsWith("image/")) {
      const reader = new FileReader();
      reader.onload = () => {
        setCropSrc(reader.result);
        setPendingFile(file);
        setCrop({ x: 0, y: 0 });
        setZoom(1);
        setCropModalOpen(true);
      };
      reader.readAsDataURL(file);
    } else {
      setImageFileValidationError(true)
    }
  };

  const handleCropConfirm = async () => {
    const compressed = await cropAndCompressToFile(cropSrc, croppedAreaPixels, pendingFile.name);
    setFile(URL.createObjectURL(compressed));
    setImageFile(compressed);
    setCropModalOpen(false);
    setCropSrc(null);
    setPendingFile(null);
  };

  const handleCropCancel = () => {
    setCropModalOpen(false);
    setCropSrc(null);
    setPendingFile(null);
  };

  const displayEndDate = () => {
    if (occurrence === "weekly") {
      return (
        <LocalizationProvider
          dateAdapter={AdapterDayjs}
        >
          <DatePicker data-testid="eventEndDate" label="End Date" value={dayjs(endDate)} sx={{ width: "100%" }} onChange={(newValue) => setEndDate(newValue)} minDate={dayjs(startDate)} format="DD/MM/YYYY" />
        </LocalizationProvider>
      )
    }
  }

  const displayDayOfTheWeek = () => {
    if (occurrence === "weekly") {
      return (
        <Row>
          <Col md={6} className='mb-3'>
            <Autocomplete
              disablePortal
              value={dayOfTheWeek}
              onChange={(event, newValue) => {
                if (newValue !== null) {
                  console.log(newValue)
                  setDayOfTheWeek(newValue);
                }
                else {
                  setDayOfTheWeek(null)
                }
              }}
              id="combo-box-demo"
              options={daysOfTheWeek}
              renderInput={(params) => <TextField {...params} label="Select Day Of The Week" />}
            />
          </Col>
        </Row>
      )
    }
  }

  const handleOccurrenceChange = (value) => {
    setOccurrence(value)
    if (value === "oneOff") {
      setEndDate(startDate)
      setDaily(false)
      setWeekly(false)
    }
    else if (value === "weekly") {
      var startDateFromState = new Date(startDate)
      var startDateYearPlusFive = dayjs(startDateFromState).year() + 5
      console.log(startDateFromState)
      console.log(startDateYearPlusFive)
      console.log(dayjs(startDateFromState).year())
      setEndDate(dayjs(startDateFromState).year(startDateYearPlusFive))
      setWeekly(true)
    }
  }

  const displayBackButton = () => {
    if (editMode) {
      return (
        <Button
          variant="contained"
          color="primary"
          component="label"
          startIcon={<ArrowBackIcon />}
          onClick={() => navigate(-1)}
        >Return</Button>
      )
    }
  }

  const submitButtonText = () => {
    if (editMode) {
      return "Update"
    } else {
      return "Submit"
    }
  }

  const handleSetStartDate = (newValue) => {
    console.log(newValue.year() + 5)
    setStartDate(newValue)
    if (occurrence === "weekly") {
      var startDateYearPlusFive = dayjs(newValue).year() + 5
      setEndDate(dayjs(newValue).year(startDateYearPlusFive))
    }
    else {
      setEndDate(newValue)
    }
    dayOfTheWeekValue(newValue)
  }

  const dayOfTheWeekValue = (value) => {
    var dayOfWeek = dayjs(value).day()
    let day = daysOfTheWeek.find(x => x.value === dayOfWeek)
    console.log(day)
    setDayOfTheWeek(day)
  }

  const setActualEndTime = (newValue) => {
    if (occurrence !== "weekly") {
      console.log(startTime)
      var hour = dayjs(new Date(newValue)).hour()
      console.log(hour)
      var min = dayjs(new Date(newValue)).minute()
      console.log(min)
      var newEndTime = dayjs(startTime).hour(hour).minute(min)
      setEndTime(newEndTime)
    }
    else {
      var endDateHour = dayjs(new Date(newValue)).hour()
      var endDatemin = dayjs(new Date(newValue)).minute()
      var endDateNewEndTime = dayjs(endDate).hour(endDateHour).minute(endDatemin)
      setEndTime(endDateNewEndTime)
    }
  }

  const displayForm = () => {
    if (!loading) {
      return (
        <>
          <Snackbar
            data-testid="create-event-success-snackbar"
            open={success}
            autoHideDuration={5000}
            onClose={handleClose}
            message={successMessage}
          />
          <Row>
            <Col className="mb-3" variant="contained">
              {displayBackButton()}
            </Col>
          </Row>
          <Row>
            {displayVenueSearch()}
            <Col md={6} className='mb-3'>
              <Autocomplete
                data-testid="combo-box-event-type"
                disablePortal
                defaultValue={eventType}
                isOptionEqualToValue={(option, value) => option.value === value.value}
                getOptionLabel={(user) => user.label}
                onChange={(event, newValue) => {
                  setEventType(newValue ? newValue : null);
                }}
                id="combo-box-demo"
                options={options}
                renderInput={(params) => <TextField {...params} label="Event Type" />}

              />
            </Col>
          </Row>
          <Row>
            <Col md={6} className='mb-3'>
              <TextField
                sx={{ width: "100%" }}
                inputProps={{ "data-testid": "create-event-name" }}
                label="Event Name"
                variant="outlined"
                value={eventName}
                onChange={(event) => {
                  setEventName(event.target.value);
                }} />
            </Col>
            <Col md={6} className='mb-3'>
              <TextField 
              sx={{ width: "100%" }} inputProps={{ "data-testid": "create-event-description" }} multiline rows={4} label="Event Description" helperText="Please note, for security and rendering purposes emojis will not be accepted" variant="outlined" value={eventDescription}
                onChange={(event) => {
                  setEventDescription(event.target.value);
                }} />
            </Col>
          </Row>
          <Row>
            <Col className='mb-3'>
              <FormControl>
                <FormLabel data-testid="occurrence-radio-group">Occurrence Fequency</FormLabel>
                <RadioGroup
                  row
                  aria-labelledby="occurrence-radio-group"
                  value={occurrence}
                  name="radio-buttons-group"
                  onChange={(e) => handleOccurrenceChange(e.target.value)}
                >
                  <FormControlLabel sx={{ color: 'black' }} value="oneOff" control={<Radio />} label="One Off" />
                  <FormControlLabel sx={{ color: 'black' }} value="weekly" control={<Radio />} label="Weekly" />
                </RadioGroup>
              </FormControl>
            </Col>
          </Row>
          {displayDayOfTheWeek()}

          {/* START DATE */}
          <Row>
            <Col className='mb-3'>

              <LocalizationProvider
                dateAdapter={AdapterDayjs}
              >
                <DatePicker
                data-testid="eventStartDate"
                  label="Start Date"
                  sx={{ width: "100%" }}
                  onChange={(newValue) => handleSetStartDate(newValue)}
                  value={dayjs(startDate)} format="DD/MM/YYYY" minDate={dayjs(new Date())}
                />
              </LocalizationProvider>
            </Col>

            {/* END DATE */}
            <Col className='mb-3'>
              {displayEndDate()}
            </Col>
          </Row>

          {/* START TIME */}
          <Row>
            <Col className='mb-3'>
              <LocalizationProvider
                dateAdapter={AdapterDayjs}
              >
                <DateTimePicker
                  sx={{ width: "100%" }}
                  label="Start Time"
                  value={dayjs(startTime)}
                  minutesStep={30}
                  timeSteps={{ minutes: 30 }}
                  viewRenderers={{
                    hours: renderDigitalClockTimeView,
                    minutes: renderDigitalClockTimeView,
                    seconds: renderDigitalClockTimeView,
                  }}
                  ampm={false}
                  openTo="hours"
                  format="HH:mm"
                  onChange={(newValue) => setStartTime(new Date(newValue.toString()))}
                  data-testid="eventStartTime"
                />
              </LocalizationProvider>
            </Col>

            {/* END TIME */}
            <Col>
              <LocalizationProvider
                dateAdapter={AdapterDayjs}
              >
                <DateTimePicker
                  sx={{ width: "100%" }}
                  label="End Time"
                  value={dayjs(endTime)}
                  minutesStep={30}
                  timeSteps={{ minutes: 30 }}
                  viewRenderers={{
                    hours: renderDigitalClockTimeView,
                    minutes: renderDigitalClockTimeView,
                    seconds: renderDigitalClockTimeView,
                  }}
                  minTime={dayjs(startTime)}
                  ampm={false}
                  openTo="hours"
                  format="HH:mm"
                  onChange={(newValue) => setActualEndTime(newValue)}
                  data-testid="eventEndTime"
                />
              </LocalizationProvider>
            </Col>
          </Row>
          <Row className='mb-3'>
            <Col>
              <div>
                <Button
                  variant="contained"
                  color="primary"
                  component="label"
                  startIcon={<CloudUpload />}
                >
                  Upload Image
                  <Input
                    type="file"
                    style={{ display: 'none' }}
                    accept="image/*"
                    onChange={(e) => handlePreviewAndImageFile(e.target.files[0])}
                    data-testid="event-image-upload-input"
                  />
                </Button>
                <InputLabel>Images should be in JPG or PNG format, less than 5MB and 3:2 landscape ratio (recommended).</InputLabel>


                {/* Display error message if imageFileValidationError is true */}
                {imageFileValidationError && (
                  <p style={{ color: "red", fontSize: 12, marginTop: 8 }}>
                    Invalid file type. Please upload an image.
                  </p>
                )}
              </div>
            </Col>
          </Row>
          <Row>
            <Col className='mb-3'>
              {displayCaputredImage()}
            </Col>
          </Row>
          <Row>
            <Col className='mb-3'>
              <Button onClick={() => handleFormSubmit()} variant="contained" disabled={loading || imageFileValidationError}>{submitButtonText()}</Button>
            </Col>
          </Row>
        </>
      )
    }
  }

  return (
    <Container style={{ backgroundColor: "white", paddingTop: 50, paddingBottom: 50, borderRadius: 10 }}>
      {displayForm()}

      <Dialog open={cropModalOpen} onClose={handleCropCancel} maxWidth="sm" fullWidth>
        <DialogTitle>Crop Image</DialogTitle>
        <DialogContent>
          <div style={{ position: 'relative', width: '100%', height: 320, background: '#333' }}>
            <Cropper
              image={cropSrc}
              crop={crop}
              zoom={zoom}
              aspect={3/2}
              onCropChange={setCrop}
              onZoomChange={setZoom}
              onCropComplete={(_, pixels) => setCroppedAreaPixels(pixels)}
            />
          </div>
          <div style={{ marginTop: 16 }}>
            <p style={{ marginBottom: 4, fontSize: 13 }}>Zoom</p>
            <Slider
              value={zoom}
              min={1}
              max={3}
              step={0.05}
              onChange={(_, v) => setZoom(v)}
            />
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCropCancel}>Cancel</Button>
          <Button onClick={handleCropConfirm} variant="contained">Crop &amp; Use</Button>
        </DialogActions>
      </Dialog>
    </Container>
  )
}

Date.prototype.addHours = function (h) {
  this.setTime(this.getTime() + (h * 60 * 60 * 1000));
  return this;
}